import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getContestType = createAsyncThunk(
  "admin/allContestType",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/contest-type/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

  export const getSingleContestType = createAsyncThunk(
    "admin/singleContestType",
    async (ContestId, { rejectWithValue }) => {
      try {
        const response = await apiInstance.get(`/contest-type/${ContestId}`, {
          headers: authHeader(),
        });
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

export const addContestType = createAsyncThunk(
  "admin/addContestType",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/contest-type/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editContestType = createAsyncThunk(
  "admin/editContestType",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/contest-type/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteContestType = createAsyncThunk(
  "admin/deleteContestType",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/contest-type/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  contestLoading: false,
};

const contestTypeSlice = createSlice({
  name: "contestTypeSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContestType.fulfilled, (state, action) => {
      state.contestTypeData = action.payload.data;
      state.contestTypeLoading = false;
    });
    builder.addCase(getSingleContestType.fulfilled, (state, action) => {
      state.singleContestTypeData = action.payload.data;
    });
  },
});
export default contestTypeSlice.reducer;
